import ajax from '../../common/ajax.jquery';
import toast from '../../common/toast.jquery';
let md5 = require('../../common/md5');
let sending = false;
export function loginSubmit(url, data) {
  return new Promise((resolve, reject) => {
    'use strict';
    if (sending) {
      return reject({
        errCode: 9000,
        errInfo: '请勿重复提交',
      });
    }
    if (!data.username) {
      toast('请输入手机号码');
      return reject({
        errCode: -9003,
        errInfo: '请输入正确的手机号码',
      });
    }
    if (data.username && !data.username.toString().match(/^(86){0,1}1\d{10}$/)) {
      toast('请输入正确的手机号码');
      return reject({
        errCode: -9001,
        errInfo: '请输入正确的手机号码',
      });
    }
    if (!data.password.match(/^.{6,}$/)) {
      toast('请输入6位以上密码');
      reject({
        errCode: -9002,
        errInfo: '请输入6位以上密码',
      });
      return;
    }
    let param = Object.assign({}, data);
    param.password = md5(param.password);
    sending = true;
    ajax.post(url, {
      data: param,
      complete: e => {
        sending = false;
      },
    }).then(data => {
      let errInfo = data.errstr || '当前网络不稳定,稍后再试哦!\'';
      if (data.errcode == 0) {
        resolve(data);
        return;
      }
      switch (data.errcode) {
        case -1:
          errInfo = '手机号或密码错误!';
          break;
        case 101:
          errInfo = '网络异常';
          break;
        case 102:
          errInfo = data.errstr || '当前网络不稳定,稍后再试哦!\'';
          break;
        default:
          break;
      }
      toast(errInfo);
      reject({
        errCode: data.errcode,
        errInfo,
      });
    }).catch((e) => {
      toast('网络错误，请稍候再试！');
      reject({
        errCode: -9000,
        errInfo: '网络错误，请稍候再试！',
      });
    });
  });
}
export default {
  loginSubmit,
};



// WEBPACK FOOTER //
// ./src/component/register/registerLowRate/login_events.js